export default __webpack_public_path__ + "static/media/IMG_1613.dfbad11c.jpg";